import { render, staticRenderFns } from "./VoyageInfoPanel.vue?vue&type=template&id=f3468b90&scoped=true"
import script from "./VoyageInfoPanel.vue?vue&type=script&lang=js"
export * from "./VoyageInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./VoyageInfoPanel.vue?vue&type=style&index=0&id=f3468b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3468b90",
  null
  
)

export default component.exports